export const MODULOS_COMUNS: string[] = [
  '/home',
  '/produtos',
  '/categorias',
  '/estoque',
  '/vendas',
  '/caixa',
  '/cliente',
  '/meu-perfil',
  '/lgpd',
  '/notificacoes',
]

export const MODULOS_POR_SEGMENTO: Record<string, string[]> = {
  MERCEARIA: ['/importacao', '/etiquetas', '/inventario', '/fidelidade'],
  RESTAURANTE: ['/entregas', '/orcamentos', '/cardapio', '/mesas', '/salao', '/cozinha'],
  PADARIA: ['/entregas', '/fidelidade'],
  PETSHOP: ['/entregas', '/banho-tosa', '/racoes', '/pets', '/fidelidade'],
  PETSHOP_VET: ['/entregas', '/banho-tosa', '/racoes', '/pets', '/consultas', '/prontuarios', '/fidelidade'],
  ROUPA: ['/trocas', '/etiquetas', '/promocoes', '/fidelidade'],
  FARMACIA: ['/importacao', '/etiquetas', '/inventario'],
  ARMAZEM: ['/importacao', '/etiquetas', '/inventario'],
  SALAO: ['/agenda', '/servicos', '/profissionais', '/agendamentos', '/ordens-servico'],
  PAPELARIA: ['/etiquetas', '/fidelidade'],
  MATERIAL: ['/importacao', '/etiquetas', '/inventario'],
  OFICINA: ['/orcamentos', '/agenda', '/servicos', '/profissionais', '/agendamentos', '/ordens-servico'],
  OTICA: ['/orcamentos', '/trocas', '/receituarios', '/exames-optometria'],
  FLORICULTURA: ['/entregas', '/fidelidade'],
  ARTESANATO: ['/etiquetas', '/fidelidade'],
  ELETRO: ['/trocas', '/etiquetas', '/importacao'],
  GENERICO: ['/importacao', '/etiquetas', '/inventario', '/trocas', '/entregas', '/orcamentos', '/promocoes', '/fidelidade'],
  ADMIN: [], // Admin usa ALL_MODULES diretamente
}

export const MODULOS_PDV: string[] = [
  '/pdv',
]

export const ALL_MODULES: string[] = Array.from(new Set([
  ...MODULOS_COMUNS,
  ...Object.values(MODULOS_POR_SEGMENTO).flat(),
  ...MODULOS_PDV,
  '/contas-receber',
  '/contas-pagar',
  '/relatorios',
  '/comissoes',
  '/fornecedores',
  '/promocoes',
  '/funcionarios',
  // Admin-only
  '/usuarios',
  '/perfis',
  '/permissoes',
  '/configuracoes',
  '/configuracao-pix',
  '/auditoria',
  '/exportacao',
  '/segmentos',
  '/planos',
  // Servicos
  '/agenda',
  '/servicos',
  '/profissionais',
  '/agendamentos',
  '/ordens-servico',
  // Pet
  '/banho-tosa',
  '/racoes',
  '/pets',
  // Restaurante
  '/cardapio',
  '/mesas',
  '/salao',
  '/cozinha',
  // Veterinaria
  '/consultas',
  '/prontuarios',
  // Otica
  '/receituarios',
  '/exames-optometria',
  // Fiscal / NFC-e
  '/nfce',
  '/configuracao-fiscal',
  '/certificados',
  // Outros
  '/fidelidade',
  // Multi-loja
  '/dashboard-multi-loja',
]))

// Modulos de negocio (configurados no Segmento)
export const MODULOS_NEGOCIO: { value: string; label: string }[] = [
  { value: '/importacao', label: 'Importacao' },
  { value: '/etiquetas', label: 'Etiquetas' },
  { value: '/inventario', label: 'Inventario' },
  { value: '/fidelidade', label: 'Fidelidade' },
  { value: '/entregas', label: 'Entregas' },
  { value: '/orcamentos', label: 'Orcamentos' },
  { value: '/cardapio', label: 'Cardapio' },
  { value: '/mesas', label: 'Mesas' },
  { value: '/salao', label: 'Salao' },
  { value: '/cozinha', label: 'Cozinha' },
  { value: '/banho-tosa', label: 'Banho e Tosa' },
  { value: '/racoes', label: 'Racoes' },
  { value: '/pets', label: 'Pets' },
  { value: '/consultas', label: 'Consultas Vet.' },
  { value: '/prontuarios', label: 'Prontuarios' },
  { value: '/trocas', label: 'Trocas' },
  { value: '/agenda', label: 'Agenda' },
  { value: '/servicos', label: 'Servicos' },
  { value: '/profissionais', label: 'Profissionais' },
  { value: '/agendamentos', label: 'Agendamentos' },
  { value: '/ordens-servico', label: 'Ordens de Servico' },
  { value: '/receituarios', label: 'Receituarios' },
  { value: '/exames-optometria', label: 'Exames Optometria' },
  { value: '/promocoes', label: 'Promocoes' },
]

// Modulos de gestao (configurados no Plano)
export const MODULOS_GESTAO: { value: string; label: string }[] = [
  { value: '/contas-receber', label: 'Contas a Receber' },
  { value: '/contas-pagar', label: 'Contas a Pagar' },
  { value: '/relatorios', label: 'Relatorios' },
  { value: '/comissoes', label: 'Comissoes' },
  { value: '/fornecedores', label: 'Fornecedores' },
  { value: '/promocoes', label: 'Promocoes' },
  { value: '/funcionarios', label: 'Funcionarios' },
  { value: '/nfce', label: 'NFC-e' },
  { value: '/pdv', label: 'PDV' },
  { value: '/configuracao-fiscal', label: 'Config. Fiscal' },
  { value: '/certificados', label: 'Certificados' },
  { value: '/dashboard-multi-loja', label: 'Dashboard Multi-Loja' },
]

export function getModulosVisiveis(
  segmento: string,
  plano: string,
  segmentoModulosDb?: string[],
  planoModulosDb?: string[]
): string[] {
  if (segmento === 'ADMIN') {
    return [...ALL_MODULES]
  }

  const modulos = [...MODULOS_COMUNS]

  // Modulos de negocio: usa banco se disponivel, senao fallback hardcoded
  if (segmentoModulosDb && segmentoModulosDb.length > 0) {
    modulos.push(...segmentoModulosDb)
  } else {
    const segmentoModulos = MODULOS_POR_SEGMENTO[segmento] || []
    modulos.push(...segmentoModulos)
  }

  // Modulos de gestao: usa banco se disponivel, senao fallback hardcoded
  if (planoModulosDb && planoModulosDb.length > 0) {
    modulos.push(...planoModulosDb)
  } else {
    if (plano === 'COMPLETO' || plano === 'COMPLETO_PDV') {
      modulos.push('/contas-receber', '/contas-pagar', '/relatorios', '/comissoes', '/fornecedores', '/promocoes', '/funcionarios', '/nfce')
    }
    if (plano === 'COMPLETO_PDV') {
      modulos.push(...MODULOS_PDV)
    }
  }

  return Array.from(new Set(modulos))
}
